import type { BlueprintAccessibilityHeadingModifier } from '@/grove-blueprints/generated-types'

import type { ResolvedModifiers } from './resolve-modifiers'

export function resolveAccessibilityHeadingModifier(
  modifier: BlueprintAccessibilityHeadingModifier,
) {
  const attributes: ResolvedModifiers['attributes'] = {
    role: 'heading',
    'aria-level': modifier.level,
  }

  return attributes
}
